import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import { SIZES } from '../../styles/theme'
import { fixedAssets } from 'src/containers/PreCache'


const Page = styled.div`
  min-height: 100vh;
  background-image: url(${fixedAssets.regBg});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  color: #FFFFFF;
  height: 100%;
  padding-bottom: 2em;

  .mobile-show {
    display: none;
  }
  .mobile-hide {
    display: block;
  }
  .visual {
    position: absolute;
    width: 15%;
    animation: floating 3s infinite linear;
  }
  #growth {
    top: 20%;
    left: 5%;
  }
  #comfort {
    top: 10%;
    left: 83%;
  }
  #cognition {
    top: 70%;
    left: 78%;
  }
  #message {
    background: transparent;
    border: 3px dashed #fff;
    border-radius: 0;
    width: 100%;
    color: #fff;
    margin: 0 auto;
    padding: 3.5rem 2rem;
    text-align: center;

    .icon {
      width: 100px;
      margin: 0 auto;
    }
    h5 {
      font-weight: 600;
      font-size: 18px;
      margin-top: 1rem;
    }
  }

  ${SIZES.mobile} {
    padding: 1.5em 0;
    padding-top: 0;
    background-image: url(${fixedAssets.regBg});

    .mobile-hide {
      display: none;
    }
    .mobile-show {
      display: block;
    }
    #mobile-kv {
      max-width: 500px;
    }
    #message {
      font-size: 0.75em;
      padding: 1.5rem 1rem;
      width: 85%;
      max-width: 500px;
    }
    .col-md-6 {
      flex: none;
      max-width: 100%
    }
  }
  .mobile-visual {
    position: relative;
    width: 45%;
    max-width: 350px;
    animation: floating 4s infinite linear;
  }
 
`

export default function PostRegisterPage() {

  return (
    <Page>
      <Row noGutters>
        <div className='d-flex justify-content-around mt-3 mx-auto'>
          <img src={fixedAssets.growth} alt="event-visual" id="growthM" className="mobile-visual mobile-show" />
          <img src={fixedAssets.comfort} alt="event-visual" id="comfortM" className="mobile-visual mobile-show" />
        </div>

        <img width="100%" src={fixedAssets.kvTitle} alt="event-banner" className="mobile-hide d-none d-md-block mx-auto" />
        <img width="100%" src={fixedAssets.kvTitleM} alt="event-banner" className="mobile-show d-md-none d-block mx-auto" />
        <img src={fixedAssets.growth} alt="event-visual" id="growth" className="visual mobile-hide" />
        <img src={fixedAssets.comfort} alt="event-visual" id="comfort" className="visual mobile-hide" />
        <img src={fixedAssets.cognition} alt="event-visual" id="cognition" className="visual mobile-hide" />
        
        <Col md={3}></Col>
        <Col md={6}>
          <div id="message">
            <div className="icon">
              <svg width="108.595" height="108.595" viewBox="0 0 108.595 108.595">
                <path d="M109.158,54.86A54.3,54.3,0,1,1,54.86.562,54.3,54.3,0,0,1,109.158,54.86ZM48.58,83.61,88.865,43.325a3.5,3.5,0,0,0,0-4.954l-4.954-4.954a3.5,3.5,0,0,0-4.954,0L46.1,66.271,30.764,50.932a3.5,3.5,0,0,0-4.954,0l-4.954,4.954a3.5,3.5,0,0,0,0,4.954l22.77,22.77a3.5,3.5,0,0,0,4.954,0Z" transform="translate(-0.562 -0.562)" fill="#fff"/>
              </svg>
            </div>
            <h5>
              Thank you for your registration!<br />
              You will receive a confirmation email soon.
            </h5>
          </div>
        </Col>
        <Col md={3}></Col>
        <Col md={12}>
          <div className='d-flex justify-content-end mt-3 mx-auto'> 
            <img src={fixedAssets.cognition} alt="event-visual" id="cognitionM" className="mobile-visual mobile-show" />
          </div>
        </Col>
      </Row>
    </Page>
  )
}
